import React, { useEffect, useState } from "react";
import "./PengembanganDiri.css";

import CapabilitiesTab from "../components/CapabilitiesTab";
import PathwayTab from "../components/PathwayTab";
import SelfAssessmentTab from "../components/SelfAssessmentTab";
import KursusOnlineTab from "../components/KursusOnlineTab";

const tabs = [
  { id: "kapasitas", label: "Alur Pembelajaran" },
  { id: "pathway", label: "Apa Peran Anda?" },
  { id: "penilaian", label: "Nilai diri saya" },
  { id: "peran", label: "Rencana Pengembangan Diri" },
  { id: "kursus", label: "Kursus Online" },
];

export default function PengembanganDiri() {
  const getInitialTab = () => {
    const usp = new URLSearchParams(window.location.search);
    const q = usp.get("tab");
    return tabs.some((t) => t.id === q) ? q : "kapasitas";
  };

  const [activeTab, setActiveTab] = useState(getInitialTab());

  useEffect(() => {
    const usp = new URLSearchParams(window.location.search);
    usp.set("tab", activeTab);
    const newUrl = `${window.location.pathname}?${usp.toString()}${window.location.hash}`;
    window.history.replaceState(null, "", newUrl);
  }, [activeTab]);

  const renderContent = () => {
    switch (activeTab) {
      case "penilaian":
        return (
          <div className="tab-content">
            <SelfAssessmentTab />
          </div>
        );
      case "kapasitas":
        return (
          <div className="tab-content">
            <h2>Pengembangan Kapasitas Diri</h2>
            <p>
              Di sini petani dapat mengakses materi, pelatihan, dan praktik terbaik
              untuk meningkatkan kapasitas pribadi dan profesional. Konten mencakup
              manajemen kebun, literasi digital, dan kepemimpinan komunitas.
            </p>
          </div>
        );
      case "pathway":
        return (
          <div className="tab-content tab-content-pathway">
            <PathwayTab />
          </div>
        );
      case "peran":
        return (
          <div className="tab-content">
            <CapabilitiesTab />
          </div>
        );
      case "kursus":
        return (
          <div className="tab-content">
            <KursusOnlineTab />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="pengembangan-container">
      <div className="tab-menu">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={activeTab === tab.id ? "active" : ""}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      {renderContent()}
    </div>
  );
}
